const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnoonu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.3 50.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    style: {
      fill: "red"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9,39.5c8.1,0,13-4.4,13-10,0-8.6-14.3-7.7-14.3-10.6s1.1-1.9,3.2-1.9c3.4,0,6.9,1.9,8.4,3.4l4.4-5.4c-3.1-2.8-7.9-4.5-12.7-4.5H7.5v.3c1,4.5,3.9,7.2,9,8.6-1.2.3-2.6.9-3.5,1.6,1.8,3,6.9,5.4,12.7,7,3.2,1,6,1.6,6,3.2s-1.2,2-3,2c-4,0-8.4-2.5-10.2-4.3l-4.8,5.7c3.5,3.3,8.9,5,14.2,5h0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnoonu);
export default __webpack_public_path__ + "static/media/snoonu.ea5111ca80961557c054ebc0096ecb67.svg";
export { ForwardRef as ReactComponent };